/* tslint:disable */
/* eslint-disable */
/**
 * KDS API
 * Internal KDS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Sync200ResponseOneOf1
 */
export interface Sync200ResponseOneOf1 {
    /**
     * 
     * @type {Array<any>}
     * @memberof Sync200ResponseOneOf1
     */
    tabs: Array<any>;
    /**
     * 
     * @type {number}
     * @memberof Sync200ResponseOneOf1
     */
    currentEventId: number;
}

/**
 * Check if a given object implements the Sync200ResponseOneOf1 interface.
 */
export function instanceOfSync200ResponseOneOf1(value: object): value is Sync200ResponseOneOf1 {
    if (!('tabs' in value) || value['tabs'] === undefined) return false;
    if (!('currentEventId' in value) || value['currentEventId'] === undefined) return false;
    return true;
}

export function Sync200ResponseOneOf1FromJSON(json: any): Sync200ResponseOneOf1 {
    return Sync200ResponseOneOf1FromJSONTyped(json, false);
}

export function Sync200ResponseOneOf1FromJSONTyped(json: any, ignoreDiscriminator: boolean): Sync200ResponseOneOf1 {
    if (json == null) {
        return json;
    }
    return {
        
        'tabs': json['tabs'],
        'currentEventId': json['currentEventId'],
    };
}

export function Sync200ResponseOneOf1ToJSON(json: any): Sync200ResponseOneOf1 {
    return Sync200ResponseOneOf1ToJSONTyped(json, false);
}

export function Sync200ResponseOneOf1ToJSONTyped(value?: Sync200ResponseOneOf1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tabs': value['tabs'],
        'currentEventId': value['currentEventId'],
    };
}

